import { render, staticRenderFns } from "./SalesInput.vue?vue&type=template&id=28be13d4"
import script from "./SalesInput.vue?vue&type=script&lang=js"
export * from "./SalesInput.vue?vue&type=script&lang=js"
import style0 from "./SalesInput.vue?vue&type=style&index=0&id=28be13d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports